import {Component, Input, OnInit} from '@angular/core';
import {BestPerformingInfluencer} from '../../../../../models/measure/report';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {BestPerformingInfluencerComponent} from '../best-performing-influencer.component';
import {Router} from '@angular/router';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'top-performing-influencer',
  templateUrl: './top-performing-influencer.component.html',
  styleUrls: ['./top-performing-influencer.component.scss']
})
export class TopPerformingInfluencerComponent {

  @Input()
  topPerforming: BestPerformingInfluencer;
  @Input()
  index: number;
  @Input()
  isSortedByReach: boolean;

  constructor(private pdfService: PdfExportService, private router: Router, private userService: UserService) {

  }

  getImpactValue(value) {
    return value * 100;
  }

  onLoadedImage() {
    this.pdfService.updateNumberImageLoaded(BestPerformingInfluencerComponent.COMPONENT_NAME);
  }

  get countryCode() {
    if (!this.topPerforming || !this.topPerforming.country || !this.topPerforming.country.code) {
      return null;
    }
    return this.topPerforming.country.code.toLowerCase();
  }

  openInfluencerDetails() {
    return this.router.navigate([`/influencer/${this.topPerforming.influencerId}/overview`], {
      queryParams: {
        activeAccount: this.userService.getCompanyId()
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/top-performing-influencer/top-performing-influencer.component.ts